// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category_category__wed5v {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  flex-direction: column;
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh);
}
.category_inner__TTkFs {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  max-width: 500px;
  padding-bottom: 24px;
}
.category_title__yQSWY {
  color: #fff;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 24px;
}
.category_desc__Vmz4H {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 24px;
}
.category_items__mhKYN {
  display: flex;
  flex-flow: wrap;
  gap: 9px;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  width: 100%;
}
.category_item__ftRs\\+ {
  border-radius: 16px;
  border: 1px solid rgba(252, 250, 238, 0.24);
  background: rgba(80, 118, 135, 0.7);

  /* Card shadows */
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  width: 48%;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding-left: 16px;
  padding-right: 24px;
}
.category_special__AxKB7 {
  background: linear-gradient(
    90deg,
    rgba(184, 0, 31, 0.4) 0%,
    rgba(56, 75, 112, 0.4) 100%
  );
  border: 1px solid rgba(255, 169, 1, 0.5);
}
.category_name__GtBI\\+ {
  color: #fff;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding-top: 6px;
}
.category_image__rewJ2 {
  width: 32px;
  height: 32px;
  filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.24));
}
.category_brandItems__alODN {
}
.category_brandItems__alODN .category_item__ftRs\\+ {
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.24);
  background: linear-gradient(90deg, #ff4926 0%, #ef593c 100%);
  /* Card shadows */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.09),
    0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 4px 4px 0px rgba(0, 0, 0, 0.01),
    0px 4px 4px 0px rgba(0, 0, 0, 0), 0px 4px 4px 0px rgba(0, 0, 0, 0.1) inset;
  flex-direction: column;
}
.category_brandItems__alODN .category_image__rewJ2 {
  width: unset;
  height: unset;
  max-width: 100px;
}
.category_brandItems__alODN .category_name__GtBI\\+ {
}
.category_line__4HXsa {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 16px;
  padding: 0 16px;
  margin: 24px 0;
}
.category_line__4HXsa span {
  background: rgba(255, 255, 255, 0.1);
  height: 1px;
  width: 100%;
}
.category_line__4HXsa p {
  color: #fff;
  text-align: right;
  /* font-family: "Yekan Bakh VF"; */
  font-size: 14px;
  font-style: normal;
  font-weight: 325;
  line-height: 24px;
}
.category_hero__71a4h {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-height: 144px; */
  width: 40%;
}
.category_hero__71a4h img {
  width: 100%;
}
.category_categoryBox__HKm1v {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
@media screen and (min-width: 1200px) {
  .category_categoryBox__HKm1v {
    width: 50%;
    margin: auto;
    padding-top: 24px;
  }
  .category_inner__TTkFs {
    flex-direction: row;
    width: 100%;
    max-width: unset;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
  }
  .category_category__wed5v {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    flex-direction: column;
  }

  .category_item__ftRs\\+ {
    /* border: 2px solid #002d1c; */
    transition: all 0.1s ease-in-out;
    width: 32%;
  }
  .category_name__GtBI\\+ {
    font-size: 16px;
  }
  .category_item__ftRs\\+:hover {
    border: 1px solid #fff;
  }
  .category_desc__Vmz4H {
    font-size: 16px;
  }
  .category_title__yQSWY {
    font-size: 20px;
  }
  .category_items__mhKYN {
    padding: unset;
  }
  .category_brandItems__alODN .category_item__ftRs\\+ {
    width: 49%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/category/category.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mCAAmC;;EAEnC,iBAAiB;EACjB;;;;0CAIwC;EACxC,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;;;;GAIC;EACD,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;AACtD;AACA;AACA;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,4DAA4D;EAC5D,iBAAiB;EACjB;;8EAE4E;EAC5E,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;AACA;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".category {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  min-height: calc(100vh - 60px);\n  min-height: calc(100dvh);\n}\n.inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  max-width: 500px;\n  padding-bottom: 24px;\n}\n.title {\n  color: #fff;\n  text-align: center;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 24px;\n}\n.desc {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 16px;\n  margin-bottom: 24px;\n}\n.items {\n  display: flex;\n  flex-flow: wrap;\n  gap: 9px;\n  justify-content: center;\n  align-items: center;\n  padding: 0 16px;\n  width: 100%;\n}\n.item {\n  border-radius: 16px;\n  border: 1px solid rgba(252, 250, 238, 0.24);\n  background: rgba(80, 118, 135, 0.7);\n\n  /* Card shadows */\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  width: 48%;\n  height: 96px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  padding-left: 16px;\n  padding-right: 24px;\n}\n.special {\n  background: linear-gradient(\n    90deg,\n    rgba(184, 0, 31, 0.4) 0%,\n    rgba(56, 75, 112, 0.4) 100%\n  );\n  border: 1px solid rgba(255, 169, 1, 0.5);\n}\n.name {\n  color: #fff;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  padding-top: 6px;\n}\n.image {\n  width: 32px;\n  height: 32px;\n  filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.24));\n}\n.brandItems {\n}\n.brandItems .item {\n  border-radius: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.24);\n  background: linear-gradient(90deg, #ff4926 0%, #ef593c 100%);\n  /* Card shadows */\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.09),\n    0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 4px 4px 0px rgba(0, 0, 0, 0.01),\n    0px 4px 4px 0px rgba(0, 0, 0, 0), 0px 4px 4px 0px rgba(0, 0, 0, 0.1) inset;\n  flex-direction: column;\n}\n.brandItems .image {\n  width: unset;\n  height: unset;\n  max-width: 100px;\n}\n.brandItems .name {\n}\n.line {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  gap: 16px;\n  padding: 0 16px;\n  margin: 24px 0;\n}\n.line span {\n  background: rgba(255, 255, 255, 0.1);\n  height: 1px;\n  width: 100%;\n}\n.line p {\n  color: #fff;\n  text-align: right;\n  /* font-family: \"Yekan Bakh VF\"; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 24px;\n}\n.hero {\n  margin-top: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* min-height: 144px; */\n  width: 40%;\n}\n.hero img {\n  width: 100%;\n}\n.categoryBox {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n@media screen and (min-width: 1200px) {\n  .categoryBox {\n    width: 50%;\n    margin: auto;\n    padding-top: 24px;\n  }\n  .inner {\n    flex-direction: row;\n    width: 100%;\n    max-width: unset;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1200px;\n  }\n  .category {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    min-height: 100vh;\n    flex-direction: column;\n  }\n\n  .item {\n    /* border: 2px solid #002d1c; */\n    transition: all 0.1s ease-in-out;\n    width: 32%;\n  }\n  .name {\n    font-size: 16px;\n  }\n  .item:hover {\n    border: 1px solid #fff;\n  }\n  .desc {\n    font-size: 16px;\n  }\n  .title {\n    font-size: 20px;\n  }\n  .items {\n    padding: unset;\n  }\n  .brandItems .item {\n    width: 49%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category": `category_category__wed5v`,
	"inner": `category_inner__TTkFs`,
	"title": `category_title__yQSWY`,
	"desc": `category_desc__Vmz4H`,
	"items": `category_items__mhKYN`,
	"item": `category_item__ftRs+`,
	"special": `category_special__AxKB7`,
	"name": `category_name__GtBI+`,
	"image": `category_image__rewJ2`,
	"brandItems": `category_brandItems__alODN`,
	"line": `category_line__4HXsa`,
	"hero": `category_hero__71a4h`,
	"categoryBox": `category_categoryBox__HKm1v`
};
export default ___CSS_LOADER_EXPORT___;
